module.exports = __webpack_public_path__ + "images/edges_grey@1x.png?47380848";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edges_grey@1x.png
// module id = 618
// module chunks = 7